import React from 'react'
import styled from 'styled-components'
import { faFilter } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import useText from '../../common/hooks/useText'

const SOcppFilterButton = styled.button<{ numberOfSelectedFilters: number; isDropdownOpened: boolean }>`
    color: ${({ theme }) => theme.font.lightestColor};
    cursor: pointer;
    border: none;
    border-radius: 4px;
    background-color: ${({ theme }) => theme.font.darkestColor};
    padding: 7px 9px 6px 9px;
    font-size: 15px;
    position: relative;
    transform: scale(-1, 1);

    &:after {
        content: '${({ numberOfSelectedFilters }) => numberOfSelectedFilters}';
        display: ${({ numberOfSelectedFilters }) => (numberOfSelectedFilters ? 'inline' : 'none')};
        font-weight: 400;
        font-size: 10px;
        -webkit-padding-top: 4px;
        padding-top: 4px;
        width: 18px;
        position: absolute;
        background-color: ${({ theme }) => theme.font.errorColor};
        top: -7px;
        left: -8px;
        height: 18px;
        border-radius: 10px;
        pointer-events: none;
        color: #ffffff;
        transform: scale(-1, 1);
    }

    &:hover {
        background-color: ${({ theme }) => theme.font.successColor};
    }
`

export type OcppFilterButtonProps = {
    reference: React.MutableRefObject<HTMLButtonElement | null>
    action: () => void
    numberOfSelectedFilters: number
    isDropdownOpened: boolean
}

export function OcppFilterButton({
    action,
    numberOfSelectedFilters,
    reference,
    isDropdownOpened,
}: OcppFilterButtonProps): React.ReactElement {
    const text = useText()
    return (
        <SOcppFilterButton
            numberOfSelectedFilters={numberOfSelectedFilters}
            onClick={action}
            ref={reference}
            title={text('btnFilterLogs')}
            isDropdownOpened={isDropdownOpened}
        >
            <FontAwesomeIcon icon={faFilter} data-testid="filterIcon" />
        </SOcppFilterButton>
    )
}
